import React from 'react';
import { Button } from '@growthaxl/web-foundation';

interface Props {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
  errorMessage: string;
}

/**
 * View-level error boundary wrapping ESAChatView (DR-15).
 * Catches catastrophic render errors and shows a "reload conversation" fallback.
 */
export class ESAChatViewBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error: unknown): State {
    const message = error instanceof Error ? error.message : 'Unknown error';
    return { hasError: true, errorMessage: message };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo): void {
    console.error('[ESAChatViewBoundary]', error, info);
  }

  handleReload = (): void => {
    this.setState({ hasError: false, errorMessage: '' });
  };

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <div
          role="alert"
          className="flex flex-col items-center justify-center p-8 gap-3 text-text-error"
        >
          <p>Conversation error. Please reload.</p>
          <Button variant="outline" size="sm" onClick={this.handleReload}>
            Reload conversation
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
